/* GOWin® Store — diagnóstico temporal de carrito y header móvil, 2026-08-06 */
(() => {
  'use strict';

  const params = new URLSearchParams(window.location.search);
  const explicit = params.get('gowin_debug_cart');

  if (explicit === '0') {
    sessionStorage.removeItem('gowin_debug_cart');
    return;
  }

  const enabled = explicit === '1' || sessionStorage.getItem('gowin_debug_cart') === '1';
  if (!enabled || window.GowinCartScrollDiagnosticInstalled) return;

  sessionStorage.setItem('gowin_debug_cart', '1');
  window.GowinCartScrollDiagnosticInstalled = true;

  const MAX_LOGS = 24;
  const logs = [];
  let panel = null;
  let output = null;
  let lastSignature = '';
  let scrollTimer = 0;

  const time = () => new Date().toLocaleTimeString('es-CR', { hour12: false });

  const describe = (element) => {
    if (!(element instanceof Element)) return String(element || 'null');
    const id = element.id ? `#${element.id}` : '';
    const classes = [...element.classList].slice(0, 3).map((name) => `.${name}`).join('');
    return `${element.tagName.toLowerCase()}${id}${classes}`;
  };

  const compactError = (error) => {
    if (!error) return 'Error desconocido';
    return String(error.message || error.reason || error).slice(0, 240);
  };

  const stackAt = (x, y) => {
    if (!Number.isFinite(x) || !Number.isFinite(y)) return [];
    return document.elementsFromPoint(x, y).slice(0, 7).map(describe);
  };

  const cartState = (reason = 'state') => {
    const icon = document.getElementById('cart-icon-bubble');
    const drawer = document.querySelector('cart-drawer');
    const header = document.querySelector('.section-header');
    const sticky = document.querySelector('sticky-header');
    const menuDetails = document.getElementById('Details-menu-drawer-container');
    const iconRect = icon?.getBoundingClientRect();
    const iconStyle = icon ? getComputedStyle(icon) : null;
    const centerX = iconRect ? iconRect.left + iconRect.width / 2 : NaN;
    const centerY = iconRect ? iconRect.top + iconRect.height / 2 : NaN;

    return {
      reason,
      path: window.location.pathname,
      scrollY: Math.round(window.scrollY),
      viewport: `${window.innerWidth}x${window.innerHeight}`,
      icon: icon ? {
        rect: `${Math.round(iconRect.left)},${Math.round(iconRect.top)},${Math.round(iconRect.width)}x${Math.round(iconRect.height)}`,
        pointerEvents: iconStyle.pointerEvents,
        visibility: iconStyle.visibility,
        display: iconStyle.display,
        opacity: iconStyle.opacity,
        zIndex: iconStyle.zIndex,
        topStack: stackAt(centerX, centerY),
      } : null,
      drawerActive: Boolean(drawer?.classList.contains('active')),
      drawerClasses: drawer?.className || null,
      headerClasses: header?.className || null,
      stickyClasses: sticky?.className || null,
      menuOpen: Boolean(menuDetails?.hasAttribute('open')),
      rootClasses: [...document.documentElement.classList]
        .filter((name) => name.startsWith('gowin') || name.includes('menu'))
        .join(' '),
      bodyOverflow: getComputedStyle(document.body).overflow,
    };
  };

  const render = () => {
    if (!output) return;
    output.textContent = logs
      .slice(-MAX_LOGS)
      .map((entry) => `[${entry.time}] ${entry.type}\n${JSON.stringify(entry.data, null, 2)}`)
      .join('\n\n');
    output.scrollTop = output.scrollHeight;
  };

  const log = (type, data = {}) => {
    const entry = { time: time(), type, data };
    logs.push(entry);
    if (logs.length > MAX_LOGS) logs.splice(0, logs.length - MAX_LOGS);
    console.info('[GOWin cart debug]', type, data);
    render();
  };

  const installUI = () => {
    if (document.getElementById('gowin-cart-debug-toggle')) return;

    const style = document.createElement('style');
    style.id = 'gowin-cart-debug-style';
    style.textContent = `
      #gowin-cart-debug-toggle {
        position: fixed;
        left: 10px;
        bottom: calc(10px + env(safe-area-inset-bottom, 0px));
        z-index: 2147483647;
        min-width: 0;
        min-height: 40px;
        padding: 8px 12px;
        border: 0;
        border-radius: 999px;
        background: #101a2b;
        color: #fff;
        font: 600 12px/1.1 -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        letter-spacing: 0;
        box-shadow: 0 6px 22px rgba(0,0,0,.24);
      }

      #gowin-cart-debug-panel {
        position: fixed;
        left: 8px;
        right: 8px;
        bottom: calc(58px + env(safe-area-inset-bottom, 0px));
        z-index: 2147483647;
        display: none;
        max-height: 54vh;
        padding: 10px;
        border: 1px solid rgba(255,255,255,.18);
        border-radius: 12px;
        background: rgba(8,19,34,.97);
        color: #fff;
        box-shadow: 0 12px 34px rgba(0,0,0,.34);
        font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
      }

      #gowin-cart-debug-panel[data-open="true"] { display: block; }

      #gowin-cart-debug-actions {
        display: flex;
        gap: 8px;
        margin-bottom: 8px;
      }

      #gowin-cart-debug-actions button {
        min-width: 0;
        min-height: 34px;
        padding: 6px 10px;
        border: 1px solid rgba(255,255,255,.24);
        border-radius: 8px;
        background: rgba(255,255,255,.08);
        color: #fff;
        font: 600 12px/1 -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        letter-spacing: 0;
      }

      #gowin-cart-debug-output {
        max-height: calc(54vh - 52px);
        margin: 0;
        overflow: auto;
        white-space: pre-wrap;
        overflow-wrap: anywhere;
        font-size: 10px;
        line-height: 1.35;
        -webkit-overflow-scrolling: touch;
      }
    `;

    const toggle = document.createElement('button');
    toggle.id = 'gowin-cart-debug-toggle';
    toggle.type = 'button';
    toggle.textContent = 'Diagnóstico carrito';

    panel = document.createElement('section');
    panel.id = 'gowin-cart-debug-panel';
    panel.dataset.open = 'false';
    panel.setAttribute('aria-label', 'Diagnóstico temporal del carrito');

    const actions = document.createElement('div');
    actions.id = 'gowin-cart-debug-actions';

    const stateButton = document.createElement('button');
    stateButton.type = 'button';
    stateButton.textContent = 'Registrar estado';
    stateButton.addEventListener('click', () => log('manual-state', cartState('manual')));

    const copyButton = document.createElement('button');
    copyButton.type = 'button';
    copyButton.textContent = 'Copiar reporte';
    copyButton.addEventListener('click', async () => {
      const report = JSON.stringify({
        generatedAt: new Date().toISOString(),
        userAgent: navigator.userAgent,
        logs,
      }, null, 2);

      try {
        await navigator.clipboard.writeText(report);
        copyButton.textContent = 'Copiado ✓';
      } catch (error) {
        log('copy-error', { message: compactError(error) });
        copyButton.textContent = 'No se pudo copiar';
      }

      window.setTimeout(() => { copyButton.textContent = 'Copiar reporte'; }, 1400);
    });

    const closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.textContent = 'Cerrar';
    closeButton.addEventListener('click', () => { panel.dataset.open = 'false'; });

    output = document.createElement('pre');
    output.id = 'gowin-cart-debug-output';

    actions.append(stateButton, copyButton, closeButton);
    panel.append(actions, output);
    document.body.append(style, toggle, panel);

    toggle.addEventListener('click', () => {
      panel.dataset.open = panel.dataset.open === 'true' ? 'false' : 'true';
      render();
    });
  };

  const pointInside = (event, rect) => (
    rect &&
    event.clientX >= rect.left &&
    event.clientX <= rect.right &&
    event.clientY >= rect.top &&
    event.clientY <= rect.bottom
  );

  const inspectCartZone = (event, phase) => {
    const icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;

    const rect = icon.getBoundingClientRect();
    const targetIsCart = event.target instanceof Element && Boolean(event.target.closest('#cart-icon-bubble'));
    if (!targetIsCart && !pointInside(event, rect)) return;

    log(`${phase}-cart-zone`, {
      target: describe(event.target),
      coordinates: `${Math.round(event.clientX)},${Math.round(event.clientY)}`,
      defaultPrevented: event.defaultPrevented,
      stack: stackAt(event.clientX, event.clientY),
      state: cartState(phase),
    });

    window.setTimeout(() => log(`${phase}-after-450ms`, cartState(`${phase}-after`)), 450);
  };

  const wrapMethods = () => {
    const StickyHeader = customElements.get('sticky-header');
    const stickyPrototype = StickyHeader?.prototype;

    if (stickyPrototype?.closeSearchModal && !stickyPrototype.closeSearchModal.GowinDebugWrapped) {
      const nativeCloseSearchModal = stickyPrototype.closeSearchModal;
      const wrapped = function (...args) {
        log('sticky-close-search', {
          scrollY: Math.round(window.scrollY),
          hasDetailsModal: Boolean(this.querySelector?.('details-modal')),
          cachedSearchModal: describe(this.searchModal),
        });

        try {
          return nativeCloseSearchModal.apply(this, args);
        } catch (error) {
          log('sticky-close-search-error', { message: compactError(error), state: cartState('sticky-error') });
          throw error;
        }
      };
      wrapped.GowinDebugWrapped = true;
      stickyPrototype.closeSearchModal = wrapped;
    }
  };

  const wrapDrawerOpen = () => {
    const CartDrawer = customElements.get('cart-drawer');
    const prototype = CartDrawer?.prototype;
    if (!prototype?.open || prototype.open.GowinDebugWrapped) return;

    const nativeOpen = prototype.open;
    const wrapped = function (...args) {
      log('drawer-open-called', cartState('drawer-open-called'));
      const result = nativeOpen.apply(this, args);
      window.setTimeout(() => log('drawer-open-after-120ms', cartState('drawer-open-after')), 120);
      return result;
    };
    wrapped.GowinDebugWrapped = true;
    prototype.open = wrapped;
  };

  const watchClasses = () => {
    const observer = new MutationObserver(() => {
      const state = cartState('class-change');
      const signature = JSON.stringify({
        headerClasses: state.headerClasses,
        stickyClasses: state.stickyClasses,
        menuOpen: state.menuOpen,
        rootClasses: state.rootClasses,
        drawerActive: state.drawerActive,
      });

      if (signature === lastSignature) return;
      lastSignature = signature;
      log('class-change', state);
    });

    const targets = [
      document.documentElement,
      document.body,
      document.querySelector('.section-header'),
      document.querySelector('sticky-header'),
      document.getElementById('Details-menu-drawer-container'),
      document.querySelector('cart-drawer'),
    ].filter(Boolean);

    targets.forEach((target) => observer.observe(target, {
      attributes: true,
      attributeFilter: ['class', 'open', 'style'],
    }));
  };

  const init = () => {
    installUI();
    wrapMethods();
    customElements.whenDefined('cart-drawer').then(wrapDrawerOpen);
    watchClasses();

    window.addEventListener('error', (event) => {
      log('window-error', {
        message: event.message,
        source: event.filename,
        line: event.lineno,
        column: event.colno,
        state: cartState('window-error'),
      });
    }, true);

    window.addEventListener('unhandledrejection', (event) => {
      log('unhandled-rejection', {
        message: compactError(event.reason),
        state: cartState('unhandled-rejection'),
      });
    });

    document.addEventListener('pointerdown', (event) => inspectCartZone(event, 'pointerdown'), true);
    document.addEventListener('click', (event) => inspectCartZone(event, 'click'), true);

    window.addEventListener('scroll', () => {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(() => log('scroll-settled', cartState('scroll-settled')), 120);
    }, { passive: true });

    window.addEventListener('pageshow', () => log('pageshow', cartState('pageshow')));
    log('diagnostic-ready', cartState('ready'));
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init, { once: true })
    : init();
})();
